import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAuthMe = z.any()
export type TagsGetAuthMe = z.infer<typeof tagsGetAuthMe>

export const responseGetAuthMe = z.object({ "payload": z.object({ "id": z.string(), "email": z.string().email(), "name": z.string(), "accountType": z.union([z.literal("client"), z.literal("admin")]), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "privileges": z.array(z.string()), "clientRole": z.union([z.literal("READ_ONLY"), z.literal("CONSUMPTION_EDITOR"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]).optional(), "primaryUser": z.boolean().optional(), "accessibleBuildingIdsCount": z.number().optional(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "numberOfBuildings": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAuthMe = z.infer<typeof responseGetAuthMe>

interface IGetAuthMe extends BaseMethodType {
  tags: TagsGetAuthMe,
  response: ResponseGetAuthMe
}
export const URL = '/auth/me'
export const validation = {
  get: {
    tags: tagsGetAuthMe,
    response: responseGetAuthMe
  }
}
export interface AuthMe extends BaseRouteType {
  get: IGetAuthMe
}